/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import CancelAction from './CancelAction/index'
import EditAction from './EditAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Phone/Phones/Content/Phone/Edit/Content/EditOrAdd/Content/Actions"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-AjnkD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--bc-2-AjnkD': dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<div
  data-testid="Actions.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
<EditAction
  viewPath={`${viewPath}/EditAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}